import { ATLAS_APP_BASE_URL } from '@/constants';

const spotlights = [
    {
        title: 'AI and Biotechnology',
        description: `Are your students curious about how AI is driving innovation and shaping the future?
            Do they wonder how this technology will impact their future careers and the workforce of tomorrow?`,
        imageSrc: 'https://d1m0scxbrw6oep.cloudfront.net/thumbnails/6e9dfd1d-d3f1-49b8-aab3-a72ac286be7e-medium',
        buttonText: 'Watch Recording Now',
        buttonLink: `${ATLAS_APP_BASE_URL}/spotlight-futurelab`,
        'data-click-type': 'Dashboard: Educator',
        'data-click-name': 'Watch Futurelab+ Spotlight',
    },
    {
        title: 'Space Week',
        description: `Hear how Dr. Nordt leads the team of scientists and engineers responsible for developing alert-danger
            operating missions that provide observational data to advance space science knowledge.`,
        imageSrc: 'https://d1m0scxbrw6oep.cloudfront.net/thumbnails/190c7e75-f785-4df0-89c2-a3a999c59865-medium',
        buttonText: 'Watch Recording Now',
        buttonLink: `${ATLAS_APP_BASE_URL}/spotlight-space-week`,
        'data-click-type': 'Dashboard: Educator',
        'data-click-name': 'Watch Polar Bears International Spotlight',
    },
    {
        title: 'Polar Bear International',
        description: `Is your class studying wildlife conservation or biology? Watch how a variety of talents and
            expertise are needed to keep Polar Bears healthy and safe.`,
        imageSrc: 'https://d1m0scxbrw6oep.cloudfront.net/thumbnails/bbd95989-cc63-4919-ac72-91140fcec9dc-medium',
        buttonText: 'Watch Recording Now',
        buttonLink: `${ATLAS_APP_BASE_URL}/spotlight-pbi`,
        'data-click-type': 'Dashboard: Educator',
        'data-click-name': 'Watch Polar Bears International Spotlight',
    },
];

export default spotlights;
